import request from '@/sheep/request';

// 聚类
export interface Cluster {
	id : number
	clusterName : string
	tags : string
	memberCount ?: number
	avgSimilarity ?: number
	isActive ?: boolean
}

// 查询聚类详情
export const getClusterInfo = (id: number) => {
	return request({
		url: '/wish/cluster/get',
		method: 'GET',
		params: { id }
	});
}

// 查询聚类列表
export const getClusterList = () => {
	return request({
		url: '/wish/cluster/list-simple',
		method: 'GET',
	});
}

// 查询聚类排行列表
export const getClusterTopWishesList = (clusterId: number, limit: number) => {
	return request({
		url: '/wish/cluster/top-wishes',
		method: 'GET',
		params: { clusterId, limit }
	});
}

// 查询聚类愿望列表
export const getClusterWishList = (clusterId: number, pageNo: number, pageSize: number) => {
	return request({
		url: '/wish/cluster/wishes-page',
		method: 'GET',
		params: { clusterId , pageNo, pageSize}
	});
}
// 查询聚类用户列表
export const getClusterMemberList = (clusterId: number, pageNo: number, pageSize: number) => {
	return request({
		url: '/wish/cluster/members-page',
		method: 'GET',
		params: { clusterId , pageNo, pageSize}
	});
}
// 查询聚类用户画像
export const getClusterProfile = (clusterId: number) => {
	return request({
		url: '/wish/cluster/profile',
		method: 'GET',
		params: { clusterId }
	});
}

// 增加聚类访问记录
export const addClusterViewCount = (id: number) => {
	return request({
		url: '/wish/cluster/view',
		method: 'GET',
		params: { id }
	});
}